import React, { useContext } from "react";
import { FormFieldContext } from "./FormField";
import { BoxProps, TypographyProps } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { ErrorMessage } from "../Display/ErrorMessage";

interface FormFieldErrorProps {
  containerProps?: ContainerProps;
  typographyProps?: Partial<TypographyProps>;
}

type ContainerProps = Partial<BoxProps>;

const defaultContainerProps: ContainerProps = {
  marginTop: 1,
};

export const FormFieldError = ({
  containerProps = {},
  typographyProps = {},
}: FormFieldErrorProps) => {
  const contextProps = useContext(FormFieldContext);
  if (!contextProps) throw new Error();

  const {
    meta: { error },
  } = contextProps;
  const mergedContainerProps = deepmerge(defaultContainerProps, containerProps);

  return (
    <ErrorMessage error={error} boxProps={mergedContainerProps} typographyProps={typographyProps} />
  );
};
